import React from 'react';
import parse from 'html-react-parser';

export default function OptionSize({size}) {
  return size && (<div className="app-option-size">{parse(size)}</div>);
};
